import { useState } from "react";

import { BdsIconCheck, BdsIconX } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTInput } from "commonComponents/btWrappers/BTInput/BTInput";

interface IRenameCellProps {
    fileId: number;
    initialTitle: string;
    isSaving: boolean;
    onSubmit: (newTitle: string) => Promise<void>;
    onCancel: () => void;
}

export const RenameCell = ({
    fileId,
    initialTitle,
    isSaving,
    onSubmit,
    onCancel,
}: IRenameCellProps) => {
    const [value, setValue] = useState(initialTitle);

    const trimmed = value.trim();
    const canSave = !!trimmed && trimmed !== initialTitle;

    return (
        <div className="flex align-items-center bds-gap-2" onClick={(e) => e.stopPropagation()}>
            <BTInput
                id={`rename-${fileId}`}
                data-testid={`rename-input-${fileId}`}
                value={value}
                onChange={(_, next) => setValue(next)}
                onFocus={(e) => e.target.select()}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                disabled={isSaving}
                debouncingContext={{ useDebouncing: false }}
            />
            <BTButton
                type="primary"
                icon={<BdsIconCheck />}
                data-testid={`rename-save-${fileId}`}
                loading={isSaving}
                disabled={!canSave || isSaving}
                onClick={() => onSubmit(value)}
            />
            <BTButton
                type="tertiary"
                icon={<BdsIconX />}
                data-testid={`rename-cancel-${fileId}`}
                disabled={isSaving}
                onClick={onCancel}
            />
        </div>
    );
};
